import type { DialogStore } from '@ariakit/react'
import toast from 'react-hot-toast'
import { ButtonBrandLegacy } from '@/components/ui/button-brand-legacy'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import {
	Dialog,
	DialogBody,
	DialogDismiss,
	DialogFooter,
	DialogHeader,
	DialogHeading,
	DialogProvider
} from '@/components/ui/dialog-atoms'
import { Spinner } from '@/components/ui/spinner'
import { useSubmitExperienceVetting } from '@/features/experience-vetting/queries/use-submit-experience-vetting'
import { useTranslation } from '@/translations/i18n'

export const ExpVettingCriteriaConfirmationModal = ({
	store,
	isWaitlisted,
	description,
	experienceId,
	toastMessage
}: {
	store: DialogStore
	isWaitlisted: boolean
	description: string
	experienceId: number
	toastMessage: string
}) => {
	const { t } = useTranslation()

	const submitQuery = useSubmitExperienceVetting(
		{ experienceId },

		{
			onSuccess: () => {
				toast.success(toastMessage)
				store.toggle()
			}
		}
	)

	const handleSubmit = () => {
		submitQuery.mutate({ isWaitlisted, isHostApprovalNeeded: false })
	}
	return (
		<DialogProvider store={store}>
			<Dialog
				hideOnInteractOutside={!submitQuery.isPending}
				width={'480px'}
			>
				<DialogHeader>
					<DialogDismiss disabled={submitQuery.isPending} />
					<DialogHeading>
						{t('vetting:merch.commons.submission_modal_header')}
					</DialogHeading>
				</DialogHeader>
				<DialogBody className='gap-2'>
					<h3 className='font-medium text-neutral-900 text-xl'>
						{description}
					</h3>
					<p className='text-neutral-900'>
						{t(
							'vetting:merch.service.confirmation_ai_modal.description'
						)}
					</p>
				</DialogBody>
				<DialogFooter>
					<ButtonLegacy
						disabled={submitQuery.isPending}
						onClick={() => store.toggle()}
						type='button'
						variant={'tertiary'}
					>
						{t('common:cancel')}
					</ButtonLegacy>

					<ButtonBrandLegacy
						disabled={submitQuery.isPending}
						onClick={handleSubmit}
					>
						{t('common:confirm')}
						{submitQuery.isPending && <Spinner size={20} />}
					</ButtonBrandLegacy>
				</DialogFooter>
			</Dialog>
		</DialogProvider>
	)
}
